import { SearchIcon2 } from "assets/icons/SearchIcon";
import { JSXElementConstructor, Key, ReactElement, ReactFragment, ReactPortal, useState } from "react";

type Props = {
  settingSideBarData: any;
  searchValue: string;
  setSearchValue: (value: string) => void;
  selectSetting: string;
  setSelectSetting: (value: any) => void;
};

function SettingSideBar({
  settingSideBarData,
  setSearchValue,
  selectSetting,
  searchValue,
  setSelectSetting,
}: Props) {
  const [renderItems, setRenderItems] = useState(settingSideBarData);
  const onSearchItem = (value: string) => {
    setSearchValue(value);
    if (value === "") return setRenderItems(settingSideBarData);

    const filteredItems = settingSideBarData.flatMap((x: any) => {
      const itemExist = x.label.includes(value);
      if (itemExist) return x;
      const item = { ...x };
      const sub: any[] = item.subSection ? [...item.subSection] : [];
      // const subs = sub.filter((y) => y.label.includes(value));
      var result: any[] = sub.filter((i) => {
        const temp = i.tag.filter((t: string) => t.toLowerCase().includes(value.toLowerCase()));
        if (temp.length > 0) {
          return true;
        }
      });

      if (result.length > 0) {
        item.subSection = [...result];
        return item;
      }
      return [];
    });
    setRenderItems(filteredItems);
  };
  return (
    <div className="md:basis-1/4 flex flex-col  sticky  py-3">
      <div className="flex flex-row items-center px-4 w-full h-10 rounded-md border border-[#c2d1e3] ">
        <SearchIcon2 color="#aeaeae" scale={1.2} />
        <input
          className="px-3 text-blue-1"
          value={searchValue}
          onChange={(e) => onSearchItem(e.target.value)}
          style={{
            width: "100%",
            border: 0,
            outline: 0,
            background: "transparent",
          }}
          placeholder="جستجو در تنظیمات..."
        />
      </div>
      <div className="flex w-full flex-col  h-full overflow-y-auto mt-6">
        {renderItems.map(
          (
            item: {
              label:
                | string
                | number
                | boolean
                | ReactElement<any, string | JSXElementConstructor<any>>
                | ReactFragment
                | ReactPortal
                | null
                | undefined;
              subSection: any[];
            },
            index: Key | null | undefined
          ) => (
            <div key={index}>
              <span className="font-medium text-xs  text-[#8D8E8F]">{item.label}</span>
              <div className="flex flex-col mt-4 mb-6 ">
                {item.subSection?.map(
                  (
                    i: {
                      key: string;
                      ActiveIcon: string | undefined;
                      label: string;

                      icon: string | undefined;
                    },
                    index: any
                  ) => (
                    <button
                      key={i.key}
                      onClick={() => setSelectSetting(i)}
                      className={`h-10 w-full flex flex-row items-center px-4 rounded  ${
                        i.key === selectSetting ? "bg-[#F2F5FC]" : "bg-[#FEFEFE]"
                      }`}
                    >
                      {i.key === selectSetting ? (
                        <img className="ml-1" src={i.ActiveIcon} alt={i.label} />
                      ) : (
                        <img className="ml-1" src={i.icon} alt={i.label} />
                      )}
                      <span
                        className={`font-normal text-sm line-clamp-1 ${
                          i.key === selectSetting ? "text-[#3E485B]" : "text-[#6B7888]"
                        }`}
                      >
                        {i.label}
                      </span>
                    </button>
                  )
                )}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default SettingSideBar;
